<template>
  <div class="mod">
    <!-- 规则弹窗 -->
    <div class="mod_box">
      <div class="h2">我的奖品</div>
      <div class="box">
        <div class="li" v-for="(item, index) in info.my_prize" :key="index">
          <div class="time">
            <img class="img" :src="img" />{{ item.ts_name }}
          </div>
          <div style="color:#ccc">{{ item.time }}</div>
        </div>
      </div>
      <div class="btn" @click="ok()">知道了</div>
    </div>
  </div>
</template>

<script>
import img from "@/utils/img.js";
export default {
  name: "My",
  data() {
    return {
      img: img.img46,
    };
  },
  props: {
    type: Boolean,
    info: Object,
  },
  methods: {
    ok() {
      this.$emit("transfer");
    },
  },
};
</script>

<style scoped lang="scss">
/* mod */
.mod {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.431);
  z-index: 90;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mod_box {
  width: 84%;
  height: 70%;
  background: #fff;
  font-size: 14px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 20px;
  overflow: hidden;
  text-align: left;
}
.h2 {
  font-size: 20px;
  font-weight: 600;
  color: #7e33ff;
  text-align: center;
  margin-top: 10px;
}
.btn {
  width: 180px;
  height: 40px;
  line-height: 40px;
  background: #7e33ff;
  color: #fff;
  border-radius: 20px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
}
.box {
  width: 100%;
  height: 76%;
  overflow: auto;
}
.li {
  width: 100%;
  // display: flex;
  margin: 10px 0;
}
.time {
  width: 100%;
  display: flex;
  margin-bottom: 4px;
    color: #7e33ff;
}
.img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
